import { createAsyncThunk } from "@reduxjs/toolkit";
import genericUtility from "../utility/GenericUtility";
import ProductApiService from "../apiServices/ProductApiService";
import { ProductDetailsModal } from "../../interfaces/ProductObject";
import {
  setLocalFinds,
  setSearchResults,
} from "../../dataManagement/uiDb/ProductListDb";

// Thunk to fetch the products by search string
export const search = createAsyncThunk(
  "productList/search",
  async (searchRq: any, { dispatch, rejectWithValue }) => {
    const response: any = await ProductApiService.search(
      searchRq.searchString,
      searchRq.userPreferences,
      searchRq.UserLocation,
      searchRq.radius
    );
    const ProductDictionary = genericUtility.listToDictionary(
      response.contents[0].products
    );
    const productList = genericUtility.dictionaryToList(ProductDictionary);
    if (productList.length !== 0) {
      dispatch(loadProducts(productList));
      dispatch(setSearchResults());
    }
    return ProductDictionary; // Assuming the response contains the product list
  }
);

export const localFindsSearch = createAsyncThunk(
  "productList/localFindsSearch",
  async (userPreferences: any, { dispatch, rejectWithValue }) => {
    const response: any = await ProductApiService.localFindsSearch(
      userPreferences
    );
    const ProductDictionary = genericUtility.listToDictionary(
      response.contents[0].products
    );
    const productList = genericUtility.dictionaryToList(ProductDictionary);
    if (productList.length !== 0) {
      dispatch(loadProducts(productList));
      dispatch(setLocalFinds());
    }
    return ProductDictionary; // Assuming the response contains the product list
  }
);

export const categorySearch = createAsyncThunk(
  "productList/categorySearch",
  async (categoryRq: { categoryString: string; userPreferences: any }, { dispatch, rejectWithValue }) => {
    const response: any = await ProductApiService.categorySearch(
      categoryRq.categoryString,
      categoryRq.userPreferences
    );
    const ProductDictionary = genericUtility.listToDictionary(
      response.contents[0].products
    );
    const productList = genericUtility.dictionaryToList(ProductDictionary);
    if (productList.length !== 0) {
      dispatch(loadProducts(productList));
      dispatch(setSearchResults());
    }
    return ProductDictionary;
  }
);

export const loadProducts = createAsyncThunk(
  "productList/loadProducts",
  async (productList: ProductDetailsModal[]) => {
    const productIds = productList.map((product: any) => product.productId);
    const response: any = await ProductApiService.getProductsByIds(productIds);
    const productDictionary = genericUtility.listToDictionary(
      response.contents[0].products
    );
    const dictionary: Record<string, ProductDetailsModal> = {};
    productIds.forEach((productId) => {
      if (productDictionary[productId]) {
        const originalProduct = productList.find(
          (p) => p.productId === productId
        );
        if (originalProduct) {
          productDictionary[productId].searchDistance =
            originalProduct.searchDistance;
        }

        dictionary[productId] = productDictionary[productId];
      }
    });
    return dictionary;
  }
);

const ProductListThunks = { search, loadProducts, localFindsSearch, categorySearch };
export default ProductListThunks;
